import React from 'react';
import Image from 'next/image';
import styles from './ArticleDetailPage.module.css';
import { IntroSectionData } from './types';

import { img } from '@/lib/img';

interface IntroSectionProps {
    data: IntroSectionData;
}

export const IntroSection: React.FC<IntroSectionProps> = ({ data }) => {
    const { paragraphs, infographic } = data;

    if (paragraphs.length === 0 && !infographic) {
        return null;
    }

    return (
        <div className={styles.introSection}>
            <div className={`${styles.introContainer} ${!infographic?.src ? styles.fullWidth : ''}`}>
                <div className={styles.introText}>
                    {paragraphs.map((paragraph, index) => (
                        <p key={index}>{paragraph}</p>
                    ))}
                </div>
                {infographic?.src && (
                    <div className={styles.introInfographic}>
                        <Image
                            src={img(infographic.src)}
                            alt={infographic.alt}
                            width={infographic.width}
                            height={infographic.height}
                            className={styles.infographicImage}
                        />
                        {infographic.caption && (
                            <p className={styles.imageCaption}>{infographic.caption}</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};
